import { Outlet } from "react-router-dom";
import ReviewList from "./pages/ReviewList/ReviewList";

export const adminReviewsRoutes = [
  {
    path: "reviews",
    element: Outlet,
    children: [
      {
        path: "",
        element: ReviewList,
      },
    ],
  },
];
